import { useEffect, useState } from "react";
import { cn, hexToRgba } from "@/lib/utils";

type FilterBarProps = {
  children: React.ReactNode;
  className?: string;
  artistColor?: string;
};

export default function FilterBar({
  children,
  className,
  artistColor,
}: FilterBarProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const scrollContainer = document.querySelector(
      ".main-scroll-container",
    ) as HTMLElement;

    if (!scrollContainer) {
      return;
    }

    const onScroll = () => {
      const scrollTop = scrollContainer.scrollTop;
      const isScrolled = scrollTop > 200;
      setScrolled(isScrolled);
    };

    onScroll();
    scrollContainer.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      scrollContainer.removeEventListener("scroll", onScroll);
    };
  }, []);

  const borderColor = artistColor
    ? hexToRgba(artistColor, 0.5)
    : "rgba(0, 0, 0, 0.1)";

  return (
    <div
      className={cn(
        "sticky top-0 z-10 transition-all duration-200 pt-6",
        scrolled ? "border-b" : "",
        className,
      )}
      style={{
        ...(scrolled
          ? {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(16px)",
              WebkitBackdropFilter: "blur(16px)",
              borderBottom: `1px solid ${borderColor}`,
            }
          : {
              backgroundColor: "transparent",
            }),
      }}
    >
      {children}
    </div>
  );
}
